import React from 'react';
import { NavBar } from '../kuroco/AppBars';
import { ChatBanner, ChatInput } from '../kuroco/ChatChrome';
import { AiBubble, Chips, DateDivider } from '../kuroco/ChatPrimitives';
import MonthVsTargetCard from './MonthVsTargetCard';
import ActionPlanCard from './ActionPlanCard';

export default function AiReview({ data, onNavigate, settingsPath }) {
  const s = data.monthSnap;
  const focusLabel = data.focus?.label || '注力指標';

  return (
    <div className="ai-screen">
      <NavBar title="現状分析・振り返り" backLabel="AI相談" onBack={() => onNavigate('home')} settingsPath={settingsPath} />
      <ChatBanner icon="📊" title={`${s.label}の当月振り返り`} />
      <div className="chat-scroll fade">
        <DateDivider label={data.dateDividerLabel} />
        <AiBubble
          html={`${data.stylistName}さん、<strong>${s.label}</strong>の中間地点です。<br>売上 <strong>${s.salesPct != null && s.salesPct !== '—' ? `${s.salesPct}%` : '—'}</strong> · 指名率 ${s.nomination} · 客数 ${s.customers}名。<br>ボトルネックは <strong>${focusLabel}</strong>。`}
        />
        <MonthVsTargetCard data={data} />
        <ActionPlanCard actions={data.actions} recordedDays={data.recordedDays} />
        <AiBubble
          html={`残り<strong>${data.period.daysLeft}日</strong>は行動プランの積み重ねが効きます。`}
        />
        <Chips
          onNavigate={onNavigate}
          items={[
            { label: '💡 実践を深掘り', route: 'improve' },
            { label: '📝 行動を記録する', route: 'record' },
          ]}
        />
      </div>
      <ChatInput placeholder="質問を入力…" onSend={() => {}} disabled />
    </div>
  );
}
